import { useEffect, useState } from 'react';
import { winnerCards } from '../../data/winners';

const moreProjects = winnerCards
  .filter((winner) => winner.id !== 'winner-2004')
  .filter((winner) => {
    const media = winner.media.toLowerCase();
    return media.includes('drawing') || media.includes('painting') || media.includes('installation');
  })
  .slice(0, 4);

export default function JenaHKim() {
  const slides = [
    { src: '/uploads/2016/11/jena-h-kim-1280x857-1.jpg', alt: 'Jena H Kim work 1' },
    { src: '/uploads/2016/11/jenahkim1.jpg', alt: 'Jena H Kim work 2' },
    { src: '/uploads/2016/11/jenahkim2.jpg', alt: 'Jena H Kim work 3' },
    { src: '/uploads/2016/11/jenahkim3.jpg', alt: 'Jena H Kim work 4' },
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [slides.length]);

  return (
    <section className="portfolio-item-page">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <h1 className="subheading uppercase">Jena H. Kim</h1>

        <div className="portfolio-item-intro">
          <div className="portfolio-item-gallery">
            <div className="portfolio-item-slideshow">
              <div className="portfolio-item-slideshow-frame" aria-label="Jena H. Kim slideshow">
                {slides.map((slide, index) => (
                  <img
                    key={slide.src}
                    className={`portfolio-item-slide ${index === activeSlide ? 'portfolio-item-slide-active' : ''}`}
                    src={slide.src}
                    alt={slide.alt}
                    aria-hidden={index !== activeSlide}
                  />
                ))}
              </div>
              <div className="portfolio-item-slideshow-dots" aria-label="Slideshow progress">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`portfolio-item-dot ${index === activeSlide ? 'portfolio-item-dot-active' : ''}`}
                    onClick={() => setActiveSlide(index)}
                    aria-label={`Show slide ${index + 1}`}
                    aria-pressed={index === activeSlide}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="portfolio-item-description">
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 0' }}>2004</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '2rem 0 0', fontWeight: '700'}}>Juror's Statement</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>This year’s jury selected New York-based artist Jena H. Kim for the 2004 KAFA Award. Kim’s abstract compositions feature geometric shapes and lines in invented spaces, the artist’s attempt to capture multiple perspectives of a three-dimensional space. Through paintings and interventions in existing architecture, Kim explores the interaction of landscape and the constructed environment. Trained as a painter, Kim’s works often feature adhesive materials such as contact paper, tape, and vinyl, as well as marker applied directly on walls. Her playfully diagrammatic markings rendered in a readymade, flat palette explore space and surface, abstraction and gesture.</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Jurors</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Howard N. Fox, Curator of Modern and Contemporary Art, Los Angeles County Museum of Art</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Eungie Joo, Director & Curator, Gallery at REDCAT (Roy and Edna Disney/ CalArts Theater)</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>David Pagel, Art Critic, Los Angeles Times, writer and curator</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Kim received her BFA from the Cooper Union School of Art and Science in New York and her MFA in Painting and Printmaking from Yale School of Art in New Haven. She was born in Busan, South Korea, in 1973.</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>TODO</p>

            <a href='https://jenahk.com/' className='nav-link'>Artist's Website</a>
          </div>
        </div>
      </div>

      <section className="portfolio-item-more-projects w-full" aria-labelledby="more-projects-heading">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <h2 className="subheading" id="more-projects-heading" style={{ marginBottom: '1.5rem' }}>
            More projects
          </h2>
        </div>

        <div className="winners-grid portfolio-item-more-grid">
          {moreProjects.map((winner) => (
            <a
              key={winner.id}
              href={winner.href}
              className="winner-card"
              aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            >
              <img className="winner-card-image" src={winner.image} alt="" />
              <div className="winner-card-overlay">
                <div className="winner-card-portrait-wrap">
                  <img className="winner-card-portrait" src={winner.portrait} alt="" />
                </div>
                <div className="winner-card-copy">
                  <span className="winner-card-meta">
                    {winner.year} | {winner.media}
                  </span>
                  <span className="winner-card-name">{winner.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </section>
  );
}
